var Buf = require('buf');
var UserList = require('userlist');


var ServerLog = Buf.extend({
    defaults: {
        name: '*'
    },
    getType: function () {
        return 'server log';
    },
    isServerLog: function() {
        return true;
    },
    idName: function () {
        return '';
    },
    idNamespace: function () {
        return '';
    },
    getTitle: function () {
        return this.connection.getTitle();
    },
    getFullLabel: function () {
        return this.connection.getFullLabel();
    },
    initialize: function (data, options) {
        Buf.prototype.initialize.apply(this, arguments);
        this.members = new UserList(this.getUser());
    },
    connectionStateChange: function () {
        if (this.connection.isDisconnected()) {
            this.deactivate();
        } else {
            this.activate();
        }
    },
    isShowingJoinPart: function () {
        return true;
    },
    isCollapsingJoinPart: function () {
        return true;
    },
    // Prefs
    prefKeys: $.extend({}, Buf.prototype.prefKeys, {
        'expandDisco': ['collapseDisco', true]
    }),
    setCollapsingDisconnectsPref: function (enable) {
        this.setOverridePref(enable, 'expandDisco');
    },
    isCollapsingDisconnects: function () {
        return this.checkPref('expandDisco');
    }
});


module.exports = ServerLog;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/serverlog.js
// module id = LZT8
// module chunks = 1